import React, { useContext, useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import {
  Avatar, Grid, Typography, Button,
  TextField, Dialog, DialogActions, DialogContent,
  DialogTitle, Select, MenuItem, Tab, Tabs, Menu, Box, InputLabel, FormControl, Slider, Skeleton,
} from '@mui/material';
import { toast } from 'react-toastify';

import { EditSharp, ExitToAppSharp, VpnKeySharp } from '@mui/icons-material';

import styles from './profile.module.css';

import { getServiceGroups } from '../../redux/serviceGroup/serviceGroup.actions';
import { getUser, getUserIndicators, getUsers, logOut, setAuthError, updateProfile, updateUser } from '../../redux/user/user.actions';
import AssinaturaDoOperador from '../../components/AssinaturaDoOperador';

import ImageUploading from 'react-images-uploading';
import { readAndCompressImage } from 'browser-image-resizer';
import AvatarEditor from 'react-avatar-editor';
import { useDropzone } from 'react-dropzone';
import UserStatus from '../../template/UserStatus';
import { ThemeContext } from '../../components/ThemeContext/ThemeContext';
import { getProfiles } from '../../redux/profile/profile.actions';
import { set } from 'date-fns';

const Profile = (props) => {
  const currentLocalUser = JSON.parse(localStorage.getItem('user'));

  const [tabValue, setTabValue] = useState(0);
  const [openProfileDialog, setOpenProfileDialog] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  const { currentUser } = props;
  const [name, setName] = useState(currentUser?.name || '');
  const [nameError, setNameError] = useState(false); // Estado para controlar o erro do campo nome

  const { serviceGroups } = props;
  const { authError } = props;
  const { updateSuccess } = props;
  const [serviceGroup, setServiceGroup] = useState(currentUser?.service_group?.id || '');
  const [email, setEmail] = useState(currentUser?.email || '');
  const [CRMId, setCRMId] = useState(currentUser?.CRM_id || '');

  const [openPassword, setOpenPassword] = useState(false);
  const [openAvatar, setOpenAvatar] = useState(false);
  const [openLogOut, setSetOpenLogOut] = useState(false);
  const [openConfirmPassword, setOpenConfirmPassword] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);
  const isMenuOpen = Boolean(anchorEl);

  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [newPasswordConfirm, setNewPasswordConfirm] = useState('');
  const { theme } = useContext(ThemeContext);
  const { permissions } = props;

  const resizeConfig = {
    quality: 0.7,
    maxWidth: 800,
    maxHeight: 800,
    autoRotate: true,
    debug: true,
    outputType: "png",
  };

  const maxNumber = 69;
  const editorRef = useRef(null);
  const [scale, setScale] = useState(1);

  const onDrop = (acceptedFiles) => {
    const file = acceptedFiles[0];
    const reader = new FileReader();
    reader.onload = () => {
      setSelectedFile([{ data_url: reader.result }]);
    };
    reader.readAsDataURL(file);
  };

  const { getRootProps, getInputProps } = useDropzone({ onDrop, accept: 'image/*', maxFiles: 1, noClick: true });

  const baseData = {
    id: currentUser?.id,
    name: name,
    email: email ? email : currentUser?.email,
    profile_id: currentUser?.profile_id,
    service_group_id: serviceGroup ? serviceGroup : currentUser?.service_group_id,
    status: currentUser?.status,
    CRM_id: CRMId,
  };

  useEffect(() => {
    if (currentUser) {
      setName(currentUser.name);
      if (!serviceGroup) {
        setServiceGroup(currentUser.service_group?.id);
      }
    }
    // eslint-disable-next-line
  }, [currentUser]);

  const handleScaleChange = (event, newValue) => {
    setScale(newValue);
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleFileChange = async (imageList, addUpdateIndex) => {
    const newImageList = await Promise.all(
      imageList.map(async (imageFile) => {
        try {
          const compressedFile = await readAndCompressImage(imageFile.file, resizeConfig);
          return {
            data_url: imageFile.data_url,
            file: compressedFile,
          };
        } catch (error) {
          console.log(error);
        }
        return imageFile;
      })
    );
    setSelectedFile(newImageList);
  };


  const handleOpen = (dialogType) => {
    switch (dialogType) {
      case 'password':
        setOpenPassword(true);
        break;
      case 'avatar':
        setOpenAvatar(true);
        break;
      case 'profileMenu':
        setOpenProfileDialog(true);
        setEmail(currentUser?.email);
        setName(currentUser?.name);
        setServiceGroup(currentUser?.service_group?.id);
        break;
      case 'logout':
        setSetOpenLogOut(true);
        break;
      default:
        break;
    }
  };

  const handleClose = (dialogType) => {
    switch (dialogType) {
      case 'password':
        setOpenPassword(false);
        setOpenConfirmPassword(false);
        break;
      case 'avatar':
        setOpenAvatar(false);
        break;
      case 'profileMenu':
        setOpenProfileDialog(false);
        break;
      case 'logout':
        setSetOpenLogOut(false);
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    if (updateSuccess) {
      toast.success('Sua senha foi atualizada com sucesso! Mantenha-a em segurança.', {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      setNewPassword('');
      setNewPasswordConfirm('');
      setOpenPassword(false);
    }
  }, [updateSuccess]);

  useEffect(() => {
    if (authError && authError.errorStatus === 400 && authError.errorMessage.error === "Current password is incorrect") {
      toast.error(`${authError.errorMessage.password ? authError.errorMessage.password : "A senha atual está incorreta!"}`, {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }, [authError]);

  const handleUpdate = async (updateType, data) => {
    switch (updateType) {
      case 'profile':
        if (!name.trim()) {
          setNameError(true);
          toast.error("O campo de nome é obrigatório.", {
            position: "top-center",
            autoClose: 5000,
          });
          return;
        } else {
          setNameError(false);
        }
        if (!email.trim()) {
          toast.error("O campo de e-mail é obrigatório.", {
            position: "top-center",
            autoClose: 5000,
          });
          return;
        }
        toast.success('Seus dados foram atualizados com sucesso!', {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        handleClose('profileMenu');
        props.updateUser(data);
        break;
      case 'avatar':
        if (editorRef.current) {
          const canvas = editorRef.current.getImageScaledToCanvas();
          canvas.toBlob(blob => {
            const imageUrl = URL.createObjectURL(blob);
            const reader = new FileReader();

            reader.onloadend = () => {
              props.updateUser({ ...baseData, picture: reader.result });
            };

            reader.onerror = (error) => {
              console.error('Erro ao ler o blob:', error);
            };

            reader.readAsDataURL(blob);
          });
          toast.success('Sua foto de perfil foi atualizada com sucesso!', {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          handleClose('avatar')
        }
        break;
      case 'password':
        if (data.new_password !== data.new_password_confirmation || oldPassword === '') {
          toast.error(`${oldPassword ? 'A senha de confirmação e a nova senha não coincidem!' : 'Confirme sua senha atual'}`, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,

          });
          break;
        } else {
          try {
            await props.updateUser({
              ...baseData,
              password: newPassword,
              current_password: oldPassword
            });
          } catch (error) {
            toast.error(`${authError.errorMessage.password ? authError.errorMessage.password : authError.errorMessage.error}`, {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
          break;
        }
      case 'logout':
        props.logOut();
        break;
      default:
        break;
    }
  };

  const handleServiceGroupChange = (event) => {
    setServiceGroup(event.target.value);
  }

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  }

  return (
    <Grid container className={styles.profileContainer}>
      <Grid item container direction="row" alignItems="center" className={styles.profileTop}>
        <Grid item className={styles.avatarContainer}>
          <Avatar alt={currentUser?.name} src={currentUser?.picture} className={styles.profileAvatar} />
          <Grid className={styles.avatarOverlay} onClick={() => handleOpen('avatar')}>
            <EditSharp className={styles.overlayIcon} />
          </Grid>
        </Grid>
        <Grid item xs>
          <Grid container>
            <Typography variant="h4" className={styles.profileName} sx={{ marginRight: 0.5 }}>
              {currentUser && currentUser.profile ? currentUser.name
                : <Skeleton variant="text" width={100} height={40} sx={{ bgcolor: 'var(--grey-800)' }} />}
            </Typography>
            <UserStatus userId={currentUser?.user_id} isIcon={false} />
          </Grid>
          <Grid container direction={'column'}>
            <Grid item sx={{ marginRight: 2 }}>
              {currentUser && currentUser.profile ?
                <Typography className={styles.profile} sx={{ color: theme.palette.text.caption }}>
                  {currentUser.profile.name}
                </Typography> :
                <Skeleton variant="text" width={40} height={40} sx={{ bgcolor: 'var(--grey-800)' }} />
              }
            </Grid>
            <Grid item>
              {currentLocalUser && currentLocalUser.profile ?
                <Typography className={styles.profile} sx={{ color: theme.palette.text.caption }}>
                  Cód. Movidesk: {currentLocalUser.CRM_id}
                </Typography>
                : <Skeleton variant="text" width={40} height={40} sx={{ bgcolor: 'var(--grey-800)' }} />
              }
            </Grid>
          </Grid>
        </Grid>
        <Grid sx={{ display: "flex", height: "100%", alignItems: "center" }} xs>
          <Grid>
            <Button
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={() => handleOpen('profileMenu')}
              color="inherit"
              startIcon={<EditSharp style={{ color: theme.palette.background.icon }} />}
            >
              <Typography fontSize={14} >Editar dados</Typography>
            </Button>
          </Grid>
          <Grid>
            <Button
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={() => handleOpen('password')}
              color="inherit"
              startIcon={<VpnKeySharp />}
            >
              <Typography fontSize={12} >Alterar Senha</Typography>
            </Button>
          </Grid>
          <Grid >
            <Button
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={() => handleOpen('logout')}
              color="inherit"
              startIcon={<ExitToAppSharp />}
              sx={{ justifyContent: 'flex-start' }}
            >
              <Typography fontSize={12} >Sair</Typography>
            </Button>
          </Grid>
        </Grid>
        <Grid item xs></Grid>
      </Grid>
      <Grid item className={'separator'} />

      <Grid item container direction="column" className={'profileSection'}>
        <Grid item container spacing={1} sx={{ marginBottom: 1 }}>
          <Grid item>
            <Typography variant="h6" className={styles.profileDept}>Grupo de Atendimento:</Typography>
          </Grid>
          <Grid item>
            <Typography variant="h6"  >
              {currentUser && currentUser.service_group ? currentUser.service_group.description
                : <Skeleton variant="text" width={40} height={40} sx={{ bgcolor: 'var(--grey-800)' }} />}
            </Typography>
          </Grid>
        </Grid>
        <Grid item container spacing={1} sx={{ marginBottom: 1 }}>
          <Grid item>
            <Typography variant="h6" className={styles.profileDept}>Ramal (URA):</Typography>
          </Grid>
          <Grid item>
            <Typography variant="h6">
              {currentUser?.ramal ? currentUser.ramal : 'Não definido'}
            </Typography>
          </Grid>
        </Grid>
        <Grid item container spacing={1}>
          <Grid item>
            <Typography variant="h6" className={styles.profileEmail}>E-mail:</Typography>
          </Grid>
          <Grid item>
            <Typography variant="h6"  >
              {currentLocalUser && currentLocalUser.email ? currentLocalUser.email
                : <Skeleton variant="text" width={40} height={40} sx={{ bgcolor: 'var(--grey-800)' }} />}
            </Typography>
          </Grid>
        </Grid>

        {/*
          * A assinatura das ações do ticket (3º bloco da Gisele).
          *
          * Aqui, e não no diálogo "Edição de Dados", porque a api tem endpoint
          * próprio para ela -- misturar obrigaria aquele formulário a duas
          * chamadas e a decidir o que fazer quando uma passa e a outra falha.
          *
          * `getUser` depois de salvar não é zelo: a caixa de ação do ticket lê
          * a assinatura de `currentUser`, e sem recarregar a sessão o operador
          * salvaria a assinatura e continuaria assinando com a antiga até o
          * próximo login.
          */}
        <Grid item container direction="column" spacing={1} sx={{ marginTop: 1 }}>
          <Grid item>
            <Typography variant="h6" className={styles.profileDept}>Minha assinatura:</Typography>
          </Grid>
          <Grid item>
            <AssinaturaDoOperador
              usuario={currentUser}
              onSalvou={() => currentUser?.id && props.getUser(currentUser.id)}
            />
          </Grid>
        </Grid>
      </Grid>

      {tabValue === 1 && (
        <Grid item container direction="column" className={'profileSection'}>
          <Grid item container spacing={1}>
            <Grid item>
              <Typography variant="h6" className={styles.profileEmail}>E-mail:</Typography>
            </Grid>
            <Grid item>
              <Typography variant="h6"  >
                {currentLocalUser && currentLocalUser.email ? currentLocalUser.email
                  : <Skeleton variant="text" width={40} height={40} sx={{ bgcolor: 'var(--grey-800)' }} />}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      )}

      <Dialog
        open={openProfileDialog}
        onClose={() => handleClose('profileMenu')}
        sx={{
          '& .MuiDialog-paper': {
            // backgroundColor: theme.palette.background.default,
            borderRadius: '15px',
            boxShadow: '0 0 10px rgba(0, 0, 0, 0.5)',
          }
        }}
      >
        <DialogTitle sx={{ color: theme.palette.text.secondary, fontWeight: 'bold', fontSize: '1.2rem' }}>Edição de Dados</DialogTitle>
        <DialogContent>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '1rem', marginTop: '0.3rem' }}>
            <TextField
              type="text"
              label="Nome"
              required
              error={nameError}
              helperText={nameError ? "O campo de nome é obrigatório." : ''}
              defaultValue={currentUser && currentUser.profile ? currentUser.name
                : <Skeleton variant="text" width={100} height={40} />}
              onChange={e => {
                setName(e.target.value);
                if (nameError) setNameError(!e.target.value.trim());
              }}
            />
            {permissions?.includes('#profile-form') && (
              <>
                <FormControl fullWidth>
                  <InputLabel id="service-group-label">Grupo de Atendimento</InputLabel>
                  <Select
                    labelId="service-group-label"
                    label="Grupo de Atendimento"
                    value={serviceGroup}
                    onChange={handleServiceGroupChange}
                  >
                    {serviceGroups.serviceGroups.map((service) => (
                      <MenuItem value={service.id} key={service.id}>{service.description}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl fullWidth>
                  <TextField
                    type='email'
                    labelId="email-label"
                    label="Email"
                    value={email}
                    placeholder={email}
                    onChange={handleEmailChange}
                    error={!email.trim()}
                    helperText={!email.trim() && "O campo de e-mail é obrigatório."}
                    required
                  />
                </FormControl>
                <FormControl fullWidth>
                  <TextField
                    label="Código Movidesk"
                    value={CRMId}
                    onChange={({ target }) => setCRMId(target.value)}
                    variant='outlined'
                    error={nameError}
                    helperText={nameError && "O nome é obrigatório"}
                  />
                </FormControl>
              </>
            )}
          </Box>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'space-between', margin: '1rem 0' }}>
          <Button
            sx={{
              color: theme => theme.palette.error.main,
              borderRadius: '10px',
              textTransform: 'capitalize'
            }}
            onClick={() => handleClose('profileMenu')}
          >
            Cancelar
          </Button>
          <Button
            sx={{
              borderRadius: '10px',
              textTransform: 'capitalize'
            }}
            onClick={() => handleUpdate('profile',
              {
                ...baseData,
              }

            )}
          >
            Salvar
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openAvatar} onClose={() => handleClose('avatar')}
        sx={{
          '& .MuiDialog-paper': {
            backgroundColor: 'var(--blue-900)',
            borderRadius: '15px',
            boxShadow: '0 0 10px rgba(0, 0, 0, 0.5)',
          }
        }}
      >
        <DialogTitle sx={{ color: '#fff', paddingBottom: 0 }}>Mudar Foto de Perfil</DialogTitle>
        <DialogContent sx={{ paddingBottom: 0 }}>
          <Grid container flexDirection={'column'}>
            <Grid item xs>
              <ImageUploading
                value={selectedFile}
                onChange={handleFileChange}
                maxNumber={maxNumber}
                dataURLKey="data_url"
              >
                {({
                  onImageUpload,
                  isDragging,
                  dragProps,
                }) => (
                  <Grid className="upload__image-wrapper">
                    <Button
                      style={isDragging ? { color: 'red' } : undefined}
                      onClick={onImageUpload}
                      {...dragProps}
                    >
                      Clique ou arraste aqui
                    </Button>
                  </Grid>
                )}
              </ImageUploading>
            </Grid>
            {selectedFile && (
              <Grid item xs={12}>
                <Slider
                  value={scale}
                  min={1}
                  max={3}
                  step={0.01}
                  onChange={handleScaleChange}
                  aria-labelledby="input-slider"
                  sx={{ color: '#fff', marginTop: '1rem' }}
                />
              </Grid>
            )}

            <Grid item {...getRootProps()}>
              <input {...getInputProps()} />
              <AvatarEditor
                ref={editorRef} // Adicione esta propriedade
                image={selectedFile ? selectedFile[0]['data_url'] : null}
                width={300}
                height={300}
                border={50}
                borderRadius={180}
                color={[0, 0, 0, 0.6]} // RGBA
                scale={scale} // Use o estado scale aqui
                rotate={0}
              />

            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'space-between', margin: '1rem 0' }}>
          <Button sx={{
            color: theme => theme.palette.error.main,
            backgroundColor: '#fff',
            borderRadius: '10px',
            textTransform: 'capitalize'
          }} onClick={() => handleClose('avatar')}>Cancelar</Button>
          <Button sx={{
            color: theme => theme.palette.text.button,
            backgroundColor: '#fff',
            borderRadius: '10px',
            textTransform: 'capitalize'
          }}
            onClick={() => handleUpdate('avatar', {
              ...baseData,
              picture: selectedFile[0]
            })}>Enviar</Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openPassword}
        onClose={() => handleClose('password')}
        sx={{
          '& .MuiDialog-paper': {
            borderRadius: '15px',
            boxShadow: '0 0 10px rgba(0, 0, 0, 0.5)',
          }
        }}
      >
        <DialogTitle sx={{ color: theme.palette.text.secondary }}>Alterar Senha</DialogTitle>
        <DialogContent>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '1rem', marginTop: '0.3rem' }}>
            <TextField
              type="password"
              label="Senha Atual"
              onChange={e => setOldPassword(e.target.value)}
            />
            <TextField
              type="password"
              label="Nova Senha"
              onChange={e => setNewPassword(e.target.value)}
            />
            <TextField
              type="password"
              label="Confirmar Nova Senha"
              onChange={e => setNewPasswordConfirm(e.target.value)}
            />
          </Box>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'space-between', margin: '1rem 0' }}>
          <Button
            sx={{
              color: theme => theme.palette.error.main,
              borderRadius: '10px',
              textTransform: 'capitalize'
            }}
            onClick={() => handleClose('password')}
          >
            Cancelar
          </Button>
          <Button
            sx={{
              borderRadius: '10px',
              textTransform: 'capitalize'
            }}
            onClick={() => setOpenConfirmPassword(true)}
          >
            Alterar Senha
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openConfirmPassword}
        onClose={() => handleClose('password')}
        sx={{
          '& .MuiDialog-paper': {
            backgroundColor: theme.palette.background.default,
            borderRadius: '15px',
            boxShadow: '0 0 10px rgba(0, 0, 0, 0.5)',
          }
        }}
      >
        <DialogTitle sx={{ color: theme.palette.text.secondary }}>Deseja mesmo alterar a senha?</DialogTitle>
        <DialogActions sx={{ justifyContent: 'space-between', margin: '1rem 0' }}>
          <Button
            sx={{
              color: theme => theme.palette.error.main,
              borderRadius: '10px',
              textTransform: 'capitalize'
            }}
            onClick={() => setOpenConfirmPassword(false)}
          >
            Não
          </Button>
          <Button
            sx={{
              borderRadius: '10px',
              textTransform: 'capitalize'
            }}
            onClick={() => {
              handleUpdate('password',
                {
                  ...baseData,
                  old_password: oldPassword,
                  new_password: newPassword,
                  new_password_confirmation: newPasswordConfirm,
                }
              );
              setOpenConfirmPassword(false);
            }}
          >
            Sim
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openLogOut}
        onClose={() => handleClose('logout')}
        sx={{
          '& .MuiDialog-paper': {
            backgroundColor: theme.palette.background.default,
            borderRadius: '15px',
            boxShadow: '0 0 10px rgba(0, 0, 0, 0.5)',
          }
        }}
      >
        <DialogTitle sx={{ color: theme.palette.text.secondary }}>Deseja mesmo sair?</DialogTitle>
        <DialogActions sx={{ justifyContent: 'space-between', margin: '1rem 0' }}>
          <Button
            sx={{
              color: theme => theme.palette.error.main,
              borderRadius: '10px',
              textTransform: 'capitalize'
            }}
            onClick={() => handleClose('logout')}
          >
            Cancelar
          </Button>
          <Button
            sx={{
              borderRadius: '10px',
              textTransform: 'capitalize'
            }}
            onClick={() => handleUpdate('logout', null)}
          >
            Sair
          </Button>
        </DialogActions>
      </Dialog>

    </Grid>
  )
}

const mapStateToProps = state => {
  const { user, serviceGroups } = state;
  const { currentUser, authError, updateSuccess, permissions } = user;
  return { currentUser, serviceGroups, authError, updateSuccess, user, permissions };
};

const mapDispatchToProps = dispatch => ({
  updateProfile: (profile) => dispatch(updateProfile(profile)),
  updateUser: (user) => dispatch(updateUser(user)),
  setAuthError: (error) => dispatch(setAuthError(error)),
  getUserIndicators: () => dispatch(getUserIndicators()),
  getUsers: () => dispatch(getUsers()),
  getServiceGroups: () => dispatch(getServiceGroups()),
  getUser: (id) => dispatch(getUser(id)),
  getProfiles: () => dispatch(getProfiles()),
  logOut: () => dispatch(logOut()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Profile);